import config from 'config';
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as signalR from '@aspnet/signalr';
// Actions & Constants
import { bookingApi } from 'services/http';
import { refreshToken } from 'src/store/auth/actions';
import { PATIENT_VALIDATED, PATIENT_BLOCKED } from 'services/constants';
import * as AppointmentsActions from './reducer/actions';

// Services
import { localAppointmentsFilters } from '../services/appointments';

const isScreenWithTodayData = () => {
  const isPlaningScreen = location && location.pathname &&
    (
      location.pathname.match('appointments/planning')
      || location.pathname.match('appointments/canceling')
      || location.pathname.match('appointments/communication')
    );
  const planingDate = localAppointmentsFilters.get('planingDate')
    || moment().endOf('day').format();
  const today = moment().endOf('day').format();
  return !isPlaningScreen || (isPlaningScreen && (moment(today).diff(planingDate, 'days') === 0));
};

const logger = (msg, ctx) => {
  console.log(`%c${msg}`, 'color: aquamarine');
  if (ctx) console.log(ctx);
};
const updateFromSockets = true;


export default function autoRefresh(WrappedComponent) {
  class Refresh extends Component {
    constructor() {
      super();
      this.connection;
      this.reconnectTimerId;
      this.refreshTokenTimerId;
      this.loadActualSlotData = this.loadActualSlotData.bind(this);
      this.hubInit = this.hubInit.bind(this);

      this.isManyalStopConnection = false;
      this.stopConnection = this.stopConnection.bind(this);

      this.workflowChanged = this.workflowChanged.bind(this);
      this.newUnplannedAppointment = this.newUnplannedAppointment.bind(this);
      this.patientValidated = this.patientValidated.bind(this);
      this.patientDeleted = this.patientDeleted.bind(this);

    }

    componentDidMount() {
      this.hubInit();
    }

    componentDidUpdate(prevProps) {
      const { auth: { token } } = this.props;

       if (token !== prevProps.auth.token && token) {
        logger('Token setuped or changed');
        this.hubInit();
      }
    }

    loadActualSlotData() {
      const { appointmentsActions } = this.props;
      appointmentsActions.loadUnplannedAppointments();
      if (isScreenWithTodayData()) {
        appointmentsActions.loadAppointmentsByPractId(null, null);
      }
    }


    workflowChanged(data) {
      const { appointmentsActions, currentPractitioner } = this.props;
      const appointment = data && data.booking;
      
      if (appointment && currentPractitioner) {
        logger(`WorkflowChanged: ${appointment.id}`, appointment);
        appointmentsActions.loadUnplannedAppointments();
        if (isScreenWithTodayData()) {
          const apntExternalIds = appointment && appointment.practitioner && appointment.practitioner.externalIds;
          
          const isConsistAllSpec = Array.isArray(apntExternalIds) && Array.isArray(currentPractitioner.externalIds) &&
          apntExternalIds.every((s) => currentPractitioner.externalIds.includes(s));
          if (isConsistAllSpec) {
              logger(`This appointment appointment support practitioner specalty: Is updating without request`);
              appointmentsActions.resetSingleAppointmentInList(appointment.id, { ...appointment, updateFromSockets });           
          } else {
            logger('WorkflowChanged not support specaltys!');
          }
        }
      } else {
        logger('WorkflowChanged with error. Incorect input data!', appointment);
        logger('WorkflowChanged with error. Incorect input currentPractitioner!', currentPractitioner);
      }
    }

    newUnplannedAppointment() {
      const { appointmentsActions } = this.props;
      logger('GET NewUnplannedAppointment');
      appointmentsActions.loadUnplannedAppointments();
    }

    patientValidated(data) {
      logger('Patient Validated', data);
      const { appointmentsActions, appointments } = this.props;
      const items = Array.isArray(appointments) && appointments.list.filter(
        item => item.patient.id === data.patientId
      );
      if (Array.isArray(items)) {
        items.forEach(item => {
          appointmentsActions.updateSingleAppointmentInList(item.id, {
            patient: { ...item.patient, status: PATIENT_VALIDATED },
            updateFromSockets
          });
        });        
      }
    }

    patientDeleted(data) {
      logger('Patient Deleted', data);
      const { appointmentsActions, appointments } = this.props;
      const items = Array.isArray(appointments) && appointments.list.filter(
        item => item.patient.id === data.patientId
      );
      if (Array.isArray(items)) {
        items.forEach(item => {
          appointmentsActions.updateSingleAppointmentInList(item.id, {
            patient: { ...item.patient, status: PATIENT_BLOCKED },
            updateFromSockets
          });
        });
      }
    }

    stopConnection() {
      if (this.connection) {
        this.isManyalStopConnection = true;
        this.connection.stop().then(() => this.isManyalStopConnection = false);        
      }
    }

    hubInit() {
      const { auth: { token }, refresh, } = this.props;

      if (token) {
        if (this.connection && this.connection.state) {
          logger('STOP manualy when init connection and have active connection.')
          this.stopConnection()
        }
        
        //──── Init ──────────────────────────────────────────────────────────────────────────────
        this.connection = new signalR.HubConnectionBuilder()
          .withUrl(`${config.websocketApi}bookings-hub`, {
            accessTokenFactory: () => token,
            transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling,
            logger: signalR.LogLevel.Error
          })
          .build();

        //──── Events ────────────────────────────────────────────────────────────────────────────
        this.connection.on('WorkflowChanged', this.workflowChanged);
        this.connection.on('NewUnplannedAppointment', this.newUnplannedAppointment);
        this.connection.on('UnplannedAppointmentRejected', this.newUnplannedAppointment);
        this.connection.on('PatientValidated', this.patientValidated);
        this.connection.on('PatientDeleted', this.patientDeleted);

        const reconnect = () => {
          logger('=== Start ReConection  ===');
          clearTimeout(this.reconnectTimerId);
          clearTimeout(this.refreshTokenTimerId);
          this.reconnectTimerId = setTimeout(() => {            
            if (this.connection) {
              logger('==== STOP manualy when run new reconnect interation =====');
              this.stopConnection();
              this.hubInit();
            }
          }, 5000);
        };

        this.connection.onclose(err => {
          if (err) {
            logger('CLOSE WITH ERR, reconnect after 5s', err.message, err.statusCode, err.status);
            reconnect();
          } else {            
            if (!this.isManyalStopConnection) {
              logger('CLOSED WITHOUT ERR. Subscribe again.')
              this.hubInit();
            } else {
              logger('CLOSED connection');
              clearTimeout(this.reconnectTimerId);
              clearTimeout(this.refreshTokenTimerId);
            }
          }
        });

        //──── Start connection ──────────────────────────────────────────────────────────────────
        this.connection
          .start()
          .then(() => {
            logger('CONNECTED');
            clearTimeout(this.reconnectTimerId);
            clearTimeout(this.refreshTokenTimerId);
            this.loadActualSlotData();
          })
          .catch(err => {
            logger('DISCONNECTED WITH ERROR', err.message, err.statusCode, err.status);
            const { statusCode } = err;
            if (statusCode && statusCode === 401) {
              // refresh token -> token updated -> check token change -> init
              this.refreshTokenTimerId = setTimeout(() => {
                refresh(refreshToken);
              }, 5000);
            } else {
              reconnect();
            }
          });
      }
    }

    componentWillUnmount() {
      clearTimeout(this.reconnectTimerId);
      clearTimeout(this.refreshTokenTimerId);
      logger('==== Appointments screen unmount =====');
      this.stopConnection();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = state => {
    const common = state.practitioner && state.practitioner.common;
    const prList = common && common.practitionersList;
    
    return {
      auth: state.auth,
      appointments: state.practitioner.appointments,
      currentPractitioner: Array.isArray(prList) && prList.find(p => common && common.commonFilters && p.id === common.commonFilters.practitionerId),
      location: state.router.location
    }
  };

  const mapDispatchToProps = dispatch => ({
    appointmentsActions: bindActionCreators(AppointmentsActions, dispatch),
    refresh: token => dispatch(refreshToken(token))
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Refresh);
}
